import React from 'react';

import { Row, Col, Card, CardBody, CardTitle } from 'reactstrap';

import './style.css';

function Item ({ itens, titulo, selecionados, setSelecionados }) {
  function onClick (id) {
    const index = selecionados.indexOf(id);
    let _selecionados = [...selecionados];

    if (index === -1) {
      _selecionados.push(id);
    } else {
      _selecionados.splice(index, 1);
    }
    setSelecionados(_selecionados);
  }

  return (
    <div className={'mv-requisicao-material-item'}>
      {itens.map(item => (
        <Card key={item.value} onClick={() => onClick(item.value)}>
          <Row>
            <Col sm='1'>
              <CardBody className='checkbox'>
                <i
                  className={
                    selecionados.indexOf(item.value) === -1
                      ? 'far fa-square'
                      : 'far fa-check-square'
                  }
                ></i>
              </CardBody>
            </Col>
            <Col>
              <CardBody>
                <CardTitle>{`${titulo} ${item.label}`}</CardTitle>
              </CardBody>
            </Col>
          </Row>
        </Card>
      ))}
    </div>
  );
}

export default Item;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Requisicao/modais/AdicionarRequisicao/Item/index.js